import { Flex, useColorModeValue, Stack, Heading, Button, Box} from "@chakra-ui/react"
import { useNavigate } from "react-router-dom";
import { ROUTES } from '../routes';

export const AdminControl= ()=>{
    const navigate = useNavigate();


    return (
       
        <Flex
          minH={'100vh'}
        
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={5} w={'full'} mx={'auto'} maxW={'lg'} py={5} px={6}>
            <Stack align={'center'}>
              <Heading fontSize={'2xl'} textAlign={'center'}>
                لوحة التحكم
              </Heading>           
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
              <Stack spacing={4}>
  
             
             
             
                <Stack spacing={10} pt={2}>
                  <Button                                          
                    size="lg"
                    bg={'blue.400'}
                    color={'white'}
                    _hover={{
                      bg: 'blue.500',
                    }}  onClick={()=>{navigate(ROUTES.CAPTINS_LIST);}}>
                    قائمة الكباتن
                  </Button>
                </Stack>

                <Stack spacing={10} pt={2}>
                  <Button                            
                   
                    size="lg"
                    bg={'blue.400'}
                    color={'white'}
                    _hover={{
                      bg: 'blue.500',
                    }}  onClick={()=>{navigate(ROUTES.ADD_CAPTIN);}}>
                    إضافة كابتن
                  </Button>
                </Stack>

                <Stack spacing={10} pt={2}>
                  <Button                            
                   
                    size="lg"
                    bg={'blue.400'}
                    color={'white'}
                    _hover={{
                      bg: 'blue.500',
                    }}  onClick={()=>{navigate(ROUTES.CONTROL_USER);}}>
                    لوحة المستخدمين
                  </Button>
                </Stack>
               
  
               
              </Stack>
            </Box>
          </Stack>
  
        </Flex>
    )  
}